import type { TrackingFn } from '@change-corgi/core-react/tracking';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

export function shareNextdoor(
	url: string,
	text: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): void {
	openUrlWithHiddenAnchor(
		`https://nextdoor.com/sharekit/?source=change.org&body=${encodeURIComponent(text)}%20${encodeURIComponent(url)}`,
		{ newTab: true },
	);
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
